/**
 * email-helpers.js — re-exports from @tshmanager/email-shared + web-specific wrappers.
 */
import {
  tagTextColor,
  humanFileSize,
  formatRelativeTime,
  formatShortDate,
  formatLongDate,
  formatAddressDisplay,
  fileKindToBootstrapIcon,
  getFileKind,
} from '@tshmanager/email-shared'

export {
  tagTextColor,
  humanFileSize,
  formatAddressDisplay,
  fileKindToBootstrapIcon,
  getFileKind,
}

/** @deprecated use formatAddressDisplay from email-shared */
export function emailAddressFormat(addrObj) {
  return formatAddressDisplay(addrObj)
}

/** Bootstrap file icon class for a filename. */
export function fileIconClass(filename) {
  return fileKindToBootstrapIcon(getFileKind(filename ?? ''))
}

const HU_RELATIVE_LABELS = {
  justNow:   'most',
  oneMinute: '1 perce',
  minutes:   (n) => `${n} perce`,
  oneHour:   '1 órája',
  hours:     (n) => `${n} órája`,
  yesterday: 'tegnap',
  days:      (n) => `${n} napja`,
  oneWeek:   '1 hete',
  weeks:     (n) => `${n} hete`,
  oneMonth:  '1 hónapja',
  months:    (n) => `${n} hónapja`,
  years:     (n) => `${n} éve`,
}

function documentLocale() {
  if (typeof document !== 'undefined') return document.documentElement.lang || 'hu'
  return 'hu'
}

/** Human-readable relative time (Hungarian labels, web email UI). */
export function timeAgo(isoString) {
  return formatRelativeTime(isoString, HU_RELATIVE_LABELS, documentLocale())
}

/** Short date format — mirrors Rails l(time, format: :short). */
export function formatDate(isoString, includeYear = false) {
  return formatShortDate(isoString, documentLocale(), includeYear)
}

/** Long date format — mirrors Rails l(time, format: :long). */
export function formatDateLong(isoString) {
  return formatLongDate(isoString, documentLocale())
}
